
export function toThousandFilter(num) {
  return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}

export function toEllipsisFilter (str,maxsize=20) {
  if (!str) return ''
  if (str.length > maxsize) {
    return str.slice(0,maxsize) + '...'
  }
  return str
}